@if (visible()) {
<div class="cookie-overlay" aria-hidden="true"></div>
<div class="cookie-modal" role="dialog" aria-modal="true" aria-labelledby="cookie-modal-title">
  <div class="cookie-card">
    <img class="cookie-logo" src="assets/images/Logo_advisors_RGB.png" alt="Advisors Logo" loading="eager" fetchpriority="high" />
    <h2 class="cookie-title" id="cookie-modal-title">Essential Cookies</h2>
    <p class="cookie-text">
      This website uses only essential, strictly necessary cookies to provide core functionality and ensure secure
      usage. No analytics, tracking, or marketing cookies are used.
    </p>
    <div class="cookie-actions">
      <button #acceptBtn type="button" class="cookie-accept-btn" (click)="accept()">Accept</button>
    </div>
  </div>
</div>
}
